import { Link } from "react-router-dom";
import { Wordmark } from "./Navbar";
import Newsletter from "./Newsletter";

export default function Footer() {
  return (
    <footer className="bg-forest text-cream" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-5 py-20 md:px-10">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="font-manrope text-xs uppercase tracking-[0.15em] text-cream/60">The newsletter</p>
            <h3 className="mt-4 font-fraunces text-3xl md:text-4xl leading-tight">
              Stories from the trail, and the occasional new thing.
            </h3>
            <div className="mt-8 max-w-md">
              <Newsletter variant="footer" />
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="font-manrope text-xs uppercase tracking-[0.15em] text-cream/60">Shop</p>
            <ul className="mt-5 space-y-3 font-manrope">
              <li><Link to="/products/no-pull-dog-harness" className="hover:text-rust">Harness + Leash</Link></li>
              <li><Link to="/products/retractable-dog-leash" className="hover:text-rust">Retractable Leash</Link></li>
              <li><Link to="/products/personalized-dog-collar" className="hover:text-rust">Personalized Collar</Link></li>
              <li className="text-cream/50">Walk · Travel · Home · Groom <span className="text-xs">(soon)</span></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="font-manrope text-xs uppercase tracking-[0.15em] text-cream/60">Company</p>
            <ul className="mt-5 space-y-3 font-manrope">
              <li><Link to="/our-story" className="hover:text-rust">Our Story</Link></li>
              <li><Link to="/faq" className="hover:text-rust">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-rust">Contact</Link></li>
              <li><Link to="/shop" className="hover:text-rust">Shop all</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-20 border-t border-cream/15 pt-8">
          <p className="font-fraunces text-[16vw] leading-none tracking-tight md:text-[11rem]">
            Kindred<span className="italic font-light text-rust">Mile</span>
          </p>
        </div>

        <div className="mt-8 flex flex-col justify-between gap-4 font-manrope text-sm text-cream/60 md:flex-row md:items-center">
          <span>Every mile, together.</span>
          <nav className="flex flex-wrap gap-x-6 gap-y-2" data-testid="footer-policies" aria-label="Store policies">
            <a href="https://kindredmile.com/policies/refund-policy" className="hover:text-rust" data-testid="footer-refund-policy">Refund Policy</a>
            <a href="https://kindredmile.com/policies/shipping-policy" className="hover:text-rust" data-testid="footer-shipping-policy">Shipping Policy</a>
            <a href="https://kindredmile.com/policies/privacy-policy" className="hover:text-rust" data-testid="footer-privacy-policy">Privacy Policy</a>
            <a href="https://kindredmile.com/policies/terms-of-service" className="hover:text-rust" data-testid="footer-terms-of-service">Terms of Service</a>
          </nav>
          <span>© {new Date().getFullYear()} Kindred Mile. Made in Canada.</span>
        </div>
      </div>
    </footer>
  );
}
